module.exports = __webpack_public_path__ + "static/media/file.c79fb6b3.svg";